import { PlayerImpressionEntity } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import { presentTitle } from '@/shared/lib/movie';

import { usePrerollAnalytics } from '../../feature-player/hooks/tracker/use-preroll-analytics';

import { usePrerollsDuration } from './use-prerolls-duration';

interface Params {
    contentId: string;
}

const prerollContent: Parameters<typeof usePrerollAnalytics>[0]['eventParamsBuilder'] = ({
    uiParams: { mainUuid },
    dependencies: { getPlayerBaseInfo },
    callbackParams: [{ vsid }],
}) => {
    const baseInfo = getPlayerBaseInfo();

    const title =
        baseInfo?.content?.__typename === 'Film' || baseInfo?.content?.__typename === 'Video'
            ? presentTitle(baseInfo?.content.filmTitle) ?? '-'
            : '-';

    return {
        entityType: PlayerImpressionEntity.Preroll,
        uuid: 'preroll',
        title,
        vsid,
        mainUuid,
    };
};

export const useFilmPrerollAnalytics = ({ contentId }: Params) => {
    const prerollDuration = usePrerollsDuration(contentId);

    usePrerollAnalytics({
        prerollDuration,
        contentId,
        eventParamsBuilder: prerollContent,
    });
};
